import React from "react";
import Modal from "../components/Modal/Modal";
import styles from "./OrganizationSwitchModal.module.scss";
import Button from "../components/Button/Button";
import classNames from "classnames";
import LogoutIllustration from "../icons/are-you-sure.svg";
import { useNavigate } from "react-router-dom";
import { hideModal } from "../redux/modalStore";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const OrganizationSwitchModal = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const handleCloseModal = () => {
    dispatch(hideModal(null));
  };

  return (
    <Modal
      name="organizations_switch_modal"
      title={t("organizationSwitchModal.title")}
    >
      <div className={styles.content}>
        <img
          src={LogoutIllustration}
          alt={t("organizationSwitchModal.illustrationAlt")}
          className={styles.illustration}
        />
        <div className={styles.buttonRow}>
          <Button
            className={classNames(styles.button, styles.cancel)}
            text={t("organizationSwitchModal.cancel")}
            onClick={handleCloseModal}
          />
          <Button
            className={styles.button}
            text={t("organizationSwitchModal.confirm")}
            onClick={() => {
              navigate("/organizations");
              handleCloseModal();
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default OrganizationSwitchModal;
